import React, { createContext, useContext } from 'react';

// Create context
const WebSocketContext = createContext();

/**
 * WebSocketProvider component
 * Provides global WebSocket functions to components
 */
export const WebSocketProvider = ({ children, connect, disconnect }) => {
  return (
    <WebSocketContext.Provider value={{ connect, disconnect }}>
      {children}
    </WebSocketContext.Provider>
  );
};

/**
 * Custom hook to use WebSocket context
 */
export const useWebSocketContext = () => {
  const context = useContext(WebSocketContext);
  if (context === undefined) {
    throw new Error('useWebSocketContext must be used within a WebSocketProvider');
  }
  return context;
};

export default WebSocketContext;
